// Хелперы для работы с аутентификацией
export const authService = {
  // Сохранение данных авторизации
  login: (token, userData) => {
    localStorage.setItem('auth_token', token);
    localStorage.setItem('user_data', JSON.stringify(userData));
    localStorage.setItem('auth_time', Date.now().toString());
  },

  // Выход
  logout: () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
    localStorage.removeItem('auth_time');
  },

  // Проверка авторизации
  isAuthenticated: () => {
    const token = localStorage.getItem('auth_token');
    const authTime = localStorage.getItem('auth_time');
    
    if (!token || !authTime) {
      return false;
    }

    // Проверяем, не истекла ли сессия (24 часа)
    const sessionDuration = 24 * 60 * 60 * 1000; // 24 часа в миллисекундах
    const currentTime = Date.now();
    const loginTime = parseInt(authTime);

    if (currentTime - loginTime > sessionDuration) {
      authService.logout();
      return false;
    }

    return true;
  },

  // Получение данных пользователя
  getUser: () => {
    const userData = localStorage.getItem('user_data');
    return userData ? JSON.parse(userData) : null;
  },

  // Получение токена
  getToken: () => {
    return localStorage.getItem('auth_token');
  },
};
